import { ComponentStyleConfig } from '@chakra-ui/react'

export const link: ComponentStyleConfig = {
  baseStyle: () => ({
    color: 'blue.600',
  }),
}
